import React from "react";
import { Box } from "@mui/material";

import image1 from "../../assets/egypt.jpg";
import image2 from "../../assets/elma.jpg";
import image3 from "../../assets/Frenchitas.jpg";
import image4 from "../../assets/Lays.jpg";
import image5 from "../../assets/Leishi.jpg";
import image6 from "../../assets/Margarita.jpg";
import image7 from "../../assets/Sabritas.jpg";
import image8 from "../../assets/SaudiArabia.jpg";
import image9 from "../../assets/Smiths.jpg";
import image10 from "../../assets/Taiwan.jpg";
import image11 from "../../assets/Tapuchips.jpg";
import image12 from "../../assets/Thailand.jpg";

import LoginFooter from "./LoginFooter";
import "./MobileSign.css";
import useLoginFlow from "../../hooks/userLoginFlow";
import LoginCardSet from "./LoginCardSet";
import LoginHeader from "./LoginHeader";
import ViewMessage from "../../pages/ViewMessage";
const imageArray = [
  image1,
  image2,
  image3,
  image4,
  image5,
  image6,
  image7,
  image8,
  image9,
  image10,
  image11,
  image12,
];

// Common styles for the overlay container. It stays in normal flow (no fixed
// height / inner scroll) so the whole page scrolls when the cards don't fit.
const overlayStyles = {
  position: "relative",
  zIndex: 1,
  display: "flex",
  flexDirection: "column",
  width: "100%",
  maxWidth: "480px",
  padding: "16px",
  alignItems: "center",
  gap: "24px",
  borderRadius: "var(--Corner-radius-corner-radius-small, 8px)",
  background: "var(--Tokens-Background-Default, #F3F7FD)",
  boxShadow:
    "var(--Elevation-X-Elevation-03, 0px) var(--Elevation-Y-Elevation-03, 2px) var(--Elevation-Blur-Elevation-03, 24px) var(--Elevation-Spread-Elevation-03, 8px) var(--Elevation-Colors-Elevation-03, rgba(0, 92, 188, 0.12))",
};

// Image tiles are repeated so the background still covers the section when
// the cards are taller than a single set of images.
const backgroundImages = [...imageArray, ...imageArray];

export default function MobileSign({ setLoading }) {
  const loginFlow = useLoginFlow(setLoading);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#F5F5F5",
      }}
    >
      <LoginHeader />

      <Box
        component="main"
        sx={{
          flex: 1,
          position: "relative",
          overflow: "hidden",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          px: 2,
          py: { xs: 3, sm: 4 },
        }}
      >
        <Box
          aria-hidden="true"
          sx={{
            position: "absolute",
            inset: 0,
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)",
            gridAutoRows: "150px",
            gap: "16px",
            zIndex: 0,
          }}
        >
          {backgroundImages.map((image, index) => (
            <Box
              key={index}
              sx={{
                backgroundImage: `url(${image})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                borderRadius: "8px",
                opacity: 0.3,
              }}
            />
          ))}
        </Box>

        <Box sx={overlayStyles}>
          <LoginCardSet {...loginFlow} />
        </Box>
      </Box>
      <ViewMessage />
      <LoginFooter />
    </Box>
  );
}
